import { countriesData } from 'utils/constants/constants';

export const getCountryByCode = (code?: string) => {
  return countriesData.find((item) => item.code === code);
};

export const getCountryByLabel = (country?: string) => {
  return countriesData.find((item) => item.label === country);
};
